module.exports = __webpack_public_path__ + "img/i_quest_NORMAL_off.07561e8.png";